module.exports = __webpack_public_path__ + "static/media/image18.e745e5d0.png";